// generic dataset presentation page
// receives a json props with all info to build the page, showcase the data and create download links

import React from 'react';
import {Link} from 'react-router-dom';
import DownloadLink from '../helper/DowloadLink'

class DatasetPage extends React.Component {
    constructor(props){
        super(props)
        // grab query
        this.name = new URLSearchParams(this.props.history.location.search).get('name');
        this.state = {data:null,error:false};
        console.log(this.name)
    }

    componentDidMount(){
        // fetch data from server
        this.fetchJSON();
    }
      // fetch the json from server
    fetchJSON(){
        const data = new FormData();
        data.append('name',this.name);
        fetch('/api/getDatasets',
        {
            method: 'post',
            headers: {"Accept": "application/text"},
            mode: 'same-origin',
            body: data
        }).then (response => {
            if (response.ok) {
            response.json().then((r) => {
                if (r.length === 0 )
                    this.setState({error:true})
                else 
                    this.setState({data:r[0],error:false})
            })
            }
        }).catch ( e => {
            this.setState({error:true})
        })
    }
    render () {
        if (this.state.error)
            return (
                <div>
                    <h3>The requested dataset was not found.</h3>
                    <h4>Return to the <Link to="/Datasets"> datasets page</Link>?</h4>
                </div>
            )
        else
            return (
                <div>
                    {this.state.data === null ?
                    <div className="loader"> </div>
                    :
                    <div>
                        <div>
                            <h5>Data - {this.state.data['name']}</h5>
                            <img src={'./..' + this.state.data['folderPath'] + this.state.data["thumbnail"]}
                                alt={'./..' + this.state.data['folderPath'] + this.state.data["thumbnail"]}
                                style={{"float":"right","paddingLeft":"10px", "width":"300px"}}/>
                            <hr></hr>
                            <h7>{this.state.data['header'][0]}</h7>
                            <ul className="list-bullet" style={{"marginLeft":"20px"}}>
                                {this.state.data['header'].map( (h,i) => {
                                    if (i > 0) {
                                        return (<li>{h}</li>)
                                    }
                                })}
                            </ul>
                        </div>
                        <div>
                            {"url" in this.state.data && 
                                (
                                this.state.data["url"].length > 10 &&
                                <div>
                                    <hr></hr>
                                    <h7><b>External url: </b></h7>
                                    <a style={{"marginLeft":"10px"}} href={this.state.data["url"]} target="_blank">{this.state.data["url"]}</a>
                                </div>
                                )
                            }
                        </div>
                        <hr></hr>
                        <div style={{"marginBottom":"20px","marginLeft":"auto"}}>
                            <h7><b>Download</b>
                                <span style={{"marginLeft":"10px"}}>
                                    <button className="btn btn-primary" style={{margin: "5px"}}
                                        onClick={ () => {
                                            const element = document.createElement("a");
                                            const file = new Blob([JSON.stringify(this.state.data,null,2)],    
                                                        {type: 'text/plain;charset=utf-8'});
                                            element.href = URL.createObjectURL(file);
                                            element.download = this.state.data["name"] + ".json";
                                            document.body.appendChild(element);
                                            element.click();
                                        }
                                        }>
                                        Download metadata (json){' '}
                                        <svg className="icon" aria-hidden="true">
                                            <use xlinkHref="#icon-upload"></use>
                                        </svg>
                                    </button>
                                </span>
                            </h7>

                            <hr></hr>
                            <table className="table" style={{"width":"100%","maxWidth":"900px"}}>
                                <thead><tr>
                                    <th>Modality</th>
                                    <th>Link to Download</th>
                                    <th>Format</th>
                                    <th>Size</th>
                                </tr></thead>
                                <tbody>
                                    {this.state.data['data'].map((d) => {
                                        return (
                                            <tr>
                                                <td>{d[0]}</td>
                                                <td><DownloadLink path={"./.." +
                                                    this.state.data["folderPath"]+
                                                    d[1]} name={d[1]}/></td>
                                                <td>{d[2]}</td>
                                                <td>{d[3]}</td>
                                            </tr>
                                        )
                                    })
                                    }
                                </tbody>
                            </table>
                        </div>
                        {('note' in this.state.data) && // if object data has key 'note'
                            <div>
                                <h7><b>Note</b></h7>
                                {this.state.data['note'].map(e => <p>{e}</p>)}
                            </div>
                        }
                        <div >
                            <hr></hr>
                            <table className="table" style={{"width":"50%","maxWidth":"450px"}}>
                                <tbody>
                                    {Object.keys(this.state.data['sequence']).map((p) => {
                                        return (
                                            <tr>
                                                <td>{p}</td>
                                                <td>{this.state.data['sequence'][p]}</td>
                                            </tr>
                                        )
                                    })
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                    }
                </div>
            )
    }
}

export default DatasetPage;